<template>
  <main>
    <div class="main-container">
      <div class="row">

        <div class="col s12 l8 offset-l2 card-panel recargas" style="border-radius: 20px; position: relative">
          <h3 class="page-title" style="text-align: center"> Recargas por tipo de carrier</h3>
          <div class="row">
            <div class="col s2 offset-s9 l1 offset-l10 card-panel waves-effect waves-light btn tooltipped blue-grey darken-3"
              @click="gonew()"
              id="newUSer"
              data-position="top"
              data-tooltip="Agregar Usuario"
            >
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <i class="material-symbols-outlined btn-style">
                person_add
              </i>
            </div>


          <!--         <div class="col s3 button-container">-->
          <!--          <div class="waves-effect waves-light btn-large light-green accent-4"-->
          <!--               > Nuevo usuario-->
          <!--          </div>-->
          <!--        </div>-->
          </div>
          <div class="row">
            <div class="col s12 offset-l2 l8">
              <div class="input-field col s12">
                <select @change="postPlataformaCarrier('T')" v-model="plataformaTelcel">
                  <option value="" disabled selected>{{defaults}} usuario por defecto</option>
                  <option v-for="plataforma in plataformas" :value="plataforma.id">{{plataforma.usuario}} ({{plataforma.plataforma}})  </option>
                </select>
                <label>Telcel</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 offset-l2 l8">
              <div class="input-field col s12">
                <select @change="postPlataformaCarrier('M')" v-model="plataformaMovistar">
                  <option value="" disabled selected>{{defaults}} usuario por defecto</option>
                  <option v-for="plataforma in plataformas" :value="plataforma.id">{{plataforma.usuario}} ({{plataforma.plataforma}})  </option>
                </select>
                <label>Movistar</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 offset-l2 l8">
              <div class="input-field col s12">
                <select @change="postPlataformaCarrier('U')" v-model="plataformaUnefon">
                  <option value="" disabled selected>{{defaults}} usuario por defecto</option>
                  <option v-for="plataforma in plataformas"  :value="plataforma.id">{{plataforma.usuario}} ({{plataforma.plataforma}})  </option>
                </select>
                <label>Unefon</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 offset-l2 l8">
              <div class="input-field col s12">
                <select @change="postPlataformaCarrier('A')" v-model="plataformaAtt">
                  <option value="" disabled selected>{{defaults}} usuario por defecto</option>
                  <option v-for="plataforma in plataformas" :value="plataforma.id">{{plataforma.usuario}} ({{plataforma.plataforma}})  </option>
                </select>
                <label>Att</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 offset-l2 l8">
              <div class="input-field col s12">
                <select @change="postPlataformaCarrier('V')" v-model="plataformaVirgin">
                  <option value="" disabled selected>{{defaults}} usuario por defecto</option>
                  <option v-for="plataforma in plataformas" :value="plataforma.id">{{plataforma.usuario}} ({{plataforma.plataforma}})  </option>
                </select>
                <label>Virgin</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12 offset-l2 l8">
              <div class="input-field col s12">
                <select @change="postPlataformaCarrier('B')" v-model="plataformaBait">
                  <option value="" disabled selected>{{defaults}} usuario por defecto</option>
                  <option v-for="plataforma in plataformas" :value="plataforma.id">{{plataforma.usuario}} ({{plataforma.plataforma}})  </option>
                </select>
                <label>Biat</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {i18n} from "@/constantes";
import {getEmpresas, plataformasEmpresa, cambiarPlataformasEmpresa, plataformaCarrier} from "@/api/api";

export default {
  name: "recargasCarier",
  data() {
    return {
      defaults: ``,
      plataformas: [],
      carriers : {},
      plataformaUnefon:``,
      plataformaAtt: ``,
      plataformaTelcel: ``,
      plataformaMovistar: ``,
      plataformaVirgin: ``,
      plataformaBait: ``
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        M.AutoInit()

      })
    },
    gonew(){
      let instance = M.Tooltip.getInstance(document.getElementById('newUSer'))
      instance.close()
      this.$router.push({name: 'nuevoUsuarioPlataforma'})
    },

    postPlataformaCarrier(carrier){
      let auxPlataforma = this.plataformaMovistar
      if(carrier == 'U')auxPlataforma = this.plataformaUnefon
      else if(carrier == 'A') auxPlataforma = this.plataformaAtt
      else if(carrier == 'T') auxPlataforma = this.plataformaTelcel
      else if(carrier == 'V') auxPlataforma = this.plataformaVirgin
      else if(carrier == 'B') auxPlataforma = this.plataformaBait
      console.log(carrier, auxPlataforma)
      cambiarPlataformasEmpresa(carrier, auxPlataforma).then(()=>{

      }).catch(error=>{
        let auxMessage = `Ocurrio un error`
        if (error.mensaje) auxMessage = error.mensaje
        M.toast({html: `${auxMessage}`, classes: 'rounded', displayLength: 150000})
        console.log(error)
      })
    }

  },
  mounted() {
    this.$nextTick(() => {
      getEmpresas().then(resp => {
        console.log(resp, 12132132132)
        this.defaults = resp.data.noPlataforma == 2 ? `${resp.data.usuario2} (${resp.data.plataforma2})` : `${resp.data.usuario} (${resp.data.plataforma})`
        return plataformasEmpresa()
      }).then(resp => {
        console.log(resp)
        this.plataformas = resp.data
        return plataformaCarrier()
      }).then(resp => {
        console.log(resp, `esasdaw`)
        resp.data.forEach(c =>{
          if(c.carrier == 'U') this.plataformaUnefon = c.empresaPlataformaId
          if(c.carrier == 'A') this.plataformaAtt = c.empresaPlataformaId
          if(c.carrier == 'T') this.plataformaTelcel = c.empresaPlataformaId
          if(c.carrier == 'M') this.plataformaMovistar = c.empresaPlataformaId
          if(c.carrier == 'B') this.plataformaBait = c.empresaPlataformaId
          if(c.carrier == 'V') this.plataformaVirgin = c.empresaPlataformaId
        })
        this.init()
      }).catch(error => {
        let auxMessage = `Ocurrio un error`
        if (error.mensaje) auxMessage = error.mensaje
        M.toast({html: `${auxMessage}`, classes: 'rounded', displayLength: 150000})
        console.log(error)
      })
    })
  },
}
</script>

<style scoped>
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}

.main-container {
  width: 94%;
  margin: 0 auto;
}
</style>